/**
 * Cart page: quantity stepper auto-update and progress bar sync.
 *
 * Handles:
 * - Quantity +/- button clicks (delegated for AJAX survival)
 * - Debounced auto-trigger of WC's update_cart after quantity change
 * - Free shipping progress bar sync after WC AJAX cart update
 *
 * @package Sansegynge
 */
(function($) {
    'use strict';

    var FREE_SHIPPING_THRESHOLD = 499;
    var updateTimer = null;

    // -------------------------------------------------------
    // Quantity +/- buttons (delegated — survives WC DOM replacement)
    // -------------------------------------------------------
    $(document).on('click', '[data-quantity-minus], [data-quantity-plus]', function() {
        var $btn   = $(this);
        var $input = $btn.closest('[data-quantity-stepper]').find('input[type="number"]');
        var val    = parseInt($input.val(), 10) || 0;
        var min    = parseInt($input.attr('min'), 10) || 0;
        var max    = parseInt($input.attr('max'), 10);

        // WC uses -1 for unlimited; max=0 or NaN also means unlimited
        if (isNaN(max) || max <= 0) {
            max = Infinity;
        }

        if ($btn.is('[data-quantity-minus]')) {
            if (val > min) {
                $input.val(val - 1).trigger('change');
            }
        } else {
            if (val < max) {
                $input.val(val + 1).trigger('change');
            }
        }

        // Debounced auto-update: 600ms after last click, trigger WC's update_cart
        clearTimeout(updateTimer);
        updateTimer = setTimeout(function() {
            $('[name="update_cart"]').prop('disabled', false).trigger('click');
        }, 600);
    });

    // -------------------------------------------------------
    // Progress bar sync after WC AJAX cart update
    // -------------------------------------------------------
    $(document.body).on('updated_wc_div updated_cart_totals', function() {
        updateProgressBar();
    });

    /**
     * Read the current subtotal from the cart totals table and
     * recalculate the free shipping progress bar state.
     */
    function updateProgressBar() {
        var $bar = $('.sg-cart-progress');
        if (!$bar.length) return;

        // Try data attribute first, fall back to cart-subtotal cell text
        var subtotalText = '';
        var $subtotalCell = $('.cart-subtotal td .woocommerce-Price-amount');
        if ($subtotalCell.length) {
            subtotalText = $subtotalCell.text();
        }

        // Parse Danish number format: "1.299,00 kr." or "499,00 kr."
        // Dots are thousand separators, comma is decimal separator
        var subtotal = parseDanishPrice(subtotalText);

        // Fall back to the data-subtotal attribute if parsing fails
        if (!subtotal || isNaN(subtotal)) {
            subtotal = parseFloat($bar.attr('data-subtotal')) || 0;
        }

        var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
        var pct = FREE_SHIPPING_THRESHOLD > 0
            ? Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100)
            : 100;

        // Update fill width with smooth transition (CSS handles it)
        $bar.find('[data-progress-fill]').css('width', pct + '%');

        // Update text content
        if (remaining <= 0) {
            $bar.find('[data-progress-text]').html(
                '<span class="flex items-center gap-2 text-success font-medium">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-success shrink-0"><path d="M20 6L9 17l-5-5"/></svg>' +
                'Billig og hurtig fragt!</span>'
            );
            $bar.find('[data-progress-fill]').removeClass('bg-accent').addClass('bg-success');
        } else {
            var formattedRemaining = remaining.toLocaleString('da-DK', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
            $bar.find('[data-progress-text]').html(
                '<span class="text-text-secondary font-light">Kun <span class="font-medium text-text-primary">' +
                formattedRemaining + ' kr.</span> fra billig fragt</span>'
            );
            $bar.find('[data-progress-fill]').removeClass('bg-success').addClass('bg-accent');
        }

        // Update data-subtotal attribute for subsequent reads
        $bar.attr('data-subtotal', subtotal);
    }

    /**
     * Parse a Danish-formatted price string into a float.
     *
     * Danish format uses dot as thousand separator and comma as decimal:
     *   "1.299,00 kr." -> 1299.00
     *   "499,00 kr."   -> 499.00
     *   "79,50 kr."    -> 79.50
     *
     * @param {string} str Price string in Danish format
     * @return {number} Parsed float value
     */
    function parseDanishPrice(str) {
        if (!str) return 0;
        // Strip everything except digits, dots, and commas
        var cleaned = str.replace(/[^0-9.,]/g, '');
        // Remove dots (thousand separators), convert comma to dot (decimal)
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
        return parseFloat(cleaned) || 0;
    }

    // -------------------------------------------------------
    // Init
    // -------------------------------------------------------
    $(document).ready(function() {
        console.log('[Sansegynge] Cart page JS loaded.');
        // Ensure progress bar state is correct on initial load
        updateProgressBar();
    });

})(jQuery);
